<mat-dialog-content class="d-flex flex-col">

    <div class="flex-row flex-space-between">
        <div>
            <mat-card-header class="p-0">
                <mat-card-title>
                    @if (!myPosts) {
                        <h3 class="m-0">Posts Library</h3>
                    }
                    @if (myPosts) {
                        <h3 class="m-0">My Comments & Posts</h3>
                    }
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button class="mat-dialog-close " mat-dialog-close mat-icon-button matTooltip="Close modal"
                    tabindex="-1">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div class="d-flex flex-col justify-content-center">
        <mat-accordion class="example-headers-align" multi>
            @if (posts.length > 0) {
                <mat-expansion-panel expanded>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Posts</mat-panel-title>
                    </mat-expansion-panel-header>
                    <table [dataSource]="posts" class="responsiveTable" mat-table>
                        <ng-container matColumnDef="name">
                            <th *matHeaderCellDef mat-header-cell>Name</th>
                            <td *matCellDef="let post" mat-cell>
                                <b class="d-none columnTitle">Name:</b> {{ post.title }}
                            </td>
                        </ng-container>
                        @if (!myPosts) {
                            <ng-container matColumnDef="author">
                                <th *matHeaderCellDef mat-header-cell>Author</th>
                                <td *matCellDef="let post" mat-cell><b
                                        class="d-none columnTitle">Author:</b> {{ post.author_username }}
                                </td>
                            </ng-container>
                        }
                        <ng-container matColumnDef="created">
                            <th *matHeaderCellDef mat-header-cell>Created At</th>
                            <td *matCellDef="let post" mat-cell><b class="d-none columnTitle">Created
                                At:</b> {{ post.created_at | date }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="likes">
                            <th *matHeaderCellDef mat-header-cell>Likes</th>
                            <td *matCellDef="let post" mat-cell><b class="d-none columnTitle">#
                                Likes:</b> {{ post.likes_count }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="comments">
                            <th *matHeaderCellDef mat-header-cell>Comments</th>
                            <td *matCellDef="let post" mat-cell><b class="d-none columnTitle">#
                                Comments:</b> {{ post.comments_count }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="view">
                            <th *matHeaderCellDef mat-header-cell></th>
                            <td *matCellDef="let post" mat-cell>
                                <button (click)="viewPost(post)" color="primary" mat-raised-button>View</button>
                            </td>
                        </ng-container>
                        <tr *matHeaderRowDef="postsColumns" mat-header-row></tr>
                        <tr *matRowDef="let row; columns: postsColumns;" mat-row></tr>
                        <tr *matNoDataRow class="mat-row">
                            <td class="mat-cell text-center"
                                colspan="6"> You have no posts yet
                            </td>
                        </tr>
                    </table>
                    <mat-paginator (page)="handlePostPageEvent($event)" [length]="postsCount"
                                   [pageSizeOptions]="[3,10, 15, 25, 50]"
                                   [pageSize]="postsLimit" aria-label="Select page"></mat-paginator>
                </mat-expansion-panel>
            }
            @if (comments.length > 0) {
                <mat-expansion-panel expanded>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Comments</mat-panel-title>
                    </mat-expansion-panel-header>
                    <table [dataSource]="comments" class="responsiveTable" mat-table>
                        <ng-container matColumnDef="comment">
                            <th *matHeaderCellDef mat-header-cell>Comment</th>
                            <td *matCellDef="let comment" mat-cell><b class="d-none columnTitle">
                                Comment:<br></b> {{ comment.text }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="created">
                            <th *matHeaderCellDef mat-header-cell>Created At</th>
                            <td *matCellDef="let comment" mat-cell><b class="d-none columnTitle">
                                Created At :</b> {{ comment.created_at | date }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="likes">
                            <th *matHeaderCellDef mat-header-cell>Likes</th>
                            <td *matCellDef="let comment" mat-cell><b class="d-none columnTitle">
                                # Likes:</b> {{ comment.likes_count }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="attachments">
                            <th *matHeaderCellDef mat-header-cell>Attachments</th>
                            <td *matCellDef="let comment" mat-cell><b class="d-none columnTitle">
                                Attachments:</b>
                                @if (!comment.attachments.length) {
                                    N/A
                                }
                                @for (attachment of comment.attachments; track attachment; let last = $last) {
                                    @if (attachment.file) {
                                        <a [href]="attachment.file"
                                           download="">{{ attachment.attachment_type |titlecase }}</a>
                                    }
                                    @if (!attachment.file) {
                                        {{ attachment.attachment_type |titlecase }}
                                    }
                                    @if (!last) {
                                        ,
                                    }
                                }
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="view">
                            <th *matHeaderCellDef mat-header-cell></th>
                            <td *matCellDef="let comment" mat-cell>
                                <button (click)="viewComment(comment)" color="primary" mat-raised-button>View</button>
                            </td>
                        </ng-container>
                        <tr *matHeaderRowDef="commentsColumns" mat-header-row></tr>
                        <tr *matRowDef="let row; columns: commentsColumns;" mat-row></tr>
                        <tr *matNoDataRow class="mat-row">
                            <td class="mat-cell text-center"
                                colspan="6"> You have no comments yet
                            </td>
                        </tr>
                    </table>
                    <mat-paginator (page)="handleCommentsPageEvent($event)" [length]="commentsCount"
                                   [pageSizeOptions]="[10, 15, 25, 50]"
                                   [pageSize]="commentsLimit" aria-label="Select page"></mat-paginator>
                </mat-expansion-panel>
            }

            @if (comments.length <= 0 && posts.length <= 0 && postsLoaded && commentsLoaded) {
                <p>No posts or comments yet!</p>
            }

            @if (!postsLoaded && !commentsLoaded) {
                <div class="d-flex justify-content-center">
                    <mat-spinner color="accent"></mat-spinner>
                </div>
            }

        </mat-accordion>
    </div>
</mat-dialog-content>

